export class Header {
  // isDefault: boolean;
  // isMenu: boolean;
  // subHeading: string;
  // subHeaderDescription: string;
  // buttonIcon: string;
  // buttonText: string;
  // buttonLabel: string;
  // statusLabel: string;
  // isStatusMenu: boolean;

  className: string;
  isHeaderRight: boolean;
  stepperData: Stepper[];
  isSubHeader: boolean;
  isSubHeaderRight: boolean;
  isSubHeaderRightStatus: boolean;
  subHeaderRightButtonLabel: string;
  headTwo: string;
  headTwoDesc: string;
  headThree: string;
  headThreeDesc: string;
  subHeaderButtonText: string;
  adjudicationStatus: string;
  showResubmit: boolean;
  isPODLocked: boolean;
  showWithdrawOption: boolean;
  adjudicationStatusToolTip: string;
  supportingDocumentCount:number=0;
  showSupportingDocumentOption:boolean;
  adjudicationId:string;
  engagementId:string;
  showSubmitOrViewMeetingGrid:boolean;
  creditorName:string;
}

export class Stepper {
  name: string;
  activePath: string;
  completePath: string;
  inCompletePath: string;
  path?: string;
  isComplete?: boolean;
  isActive?: boolean;
}
